module.exports = __webpack_public_path__ + "static/media/right_quote.4963f162.svg";